/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} FaqInputs */

const en_faq = /** @type {(inputs: FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQ`)
};

const th_faq = /** @type {(inputs: FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คำถามที่พบบ่อย`)
};

const ja_faq = /** @type {(inputs: FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`よくある質問`)
};

const fr_faq = /** @type {(inputs: FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQ`)
};

const es_faq = /** @type {(inputs: FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preguntas frecuentes`)
};

const ru_faq = /** @type {(inputs: FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вопросы и ответы`)
};

const zh_faq = /** @type {(inputs: FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`常见问题`)
};

const vi_faq = /** @type {(inputs: FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Câu hỏi thường gặp`)
};

/**
* | output |
* | --- |
* | "FAQ" |
*
* @param {FaqInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const faq = /** @type {((inputs?: FaqInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<FaqInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_faq(inputs)
	if (locale === "ja") return ja_faq(inputs)
	if (locale === "fr") return fr_faq(inputs)
	if (locale === "es") return es_faq(inputs)
	if (locale === "ru") return ru_faq(inputs)
	if (locale === "zh") return zh_faq(inputs)
	if (locale === "vi") return vi_faq(inputs)
	return en_faq(inputs)
});